import React from 'react';
import {
    Box,
    DialogContent,
    DialogActions,
    Chip,
    Button,
} from '@mui/material';
import BootstrapDialog, {
    BootstrapDialogTitle,
} from '../../common/dialog/BootstrapDialog';
import { useMemo } from 'react';
import TranInfoView from './TranInfoView';
import TranProductList from './TranProductList';
import DetailTemplate from '../../common/template/DetailTemplate';
import ProjectInfo from './ProjectInfo';
import * as invApi from '../../../lib/api/inventory';


const TranInfoViewModal = ({ open, handleClose, transInf, productList, totalPrice, handleDel }) => {

    const tranTypChip = useMemo(() => {
        if (transInf) {
            let trnTypNm = "";
            let color = "primary";
            if (transInf.trnTyp === 'I') {
                trnTypNm = "입고";

            } else if (transInf.trnTyp === 'O') {
                trnTypNm = "출고";
                color = "error";
            } else if (transInf.trnTyp === 'D') {
                trnTypNm = "폐기";
                color = "default";
            }
            return (
                <Chip label={trnTypNm} color={color} />
            )
        }

    }, [transInf]);



    return (
        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="dialog-title"
            open={open}
            fullWidth={true}
            maxWidth="lg"
        >
            <BootstrapDialogTitle id="dialog-title" onClose={handleClose}>
                {tranTypChip} {transInf?.trnNm}
            </BootstrapDialogTitle>
            <DialogContent
                dividers
                sx={{
                    height: 650,
                    overflowY: 'auto',
                }}
            >
                {transInf && transInf.trnTyp === 'O' && (
                    <DetailTemplate title="프로젝트 정보">
                        <ProjectInfo id={transInf.trnToWh} />
                    </DetailTemplate>
                )}
                <DetailTemplate title="이력 내역">
                    <TranInfoView transInf={transInf} />
                </DetailTemplate>
                <DetailTemplate title="제품 리스트">
                    <TranProductList productList={productList} totalPrice={totalPrice} />
                </DetailTemplate>

            </DialogContent>
            <DialogActions>
                <Button onClick={handleDel} color="error" variant="contained">작업취소</Button>
            </DialogActions>
        </BootstrapDialog>
    )
}

export default TranInfoViewModal;